
/*
アニメーション定義

使い方：

■アニメーションさせたいHTML要素をもつコンポーネントに設定

１．インポート
import { Fade, SlideRight,SlideLeft } from 'projects/universe/src/app/Util/AnimationUtil';

２．コンポーネント定義に追加
@Component({
	selector: 'app-fragment',
	templateUrl: './OverworkSituationFragmentComponent.html',
	styleUrls: ['./OverworkSituationFragmentComponent.scss'],

	animations: [ // これ追加
		Fade,
		SlideLeft,
		SlideRight
	],

})

■アニメーションするHTML要素をバインド

下記を要素に付けるとバインドされる
[@slideRight]='animationSlideState'

[@Trigger名]='使う変数名'
triggerの第1パラメータがトリガー名になってる。

例）
	<div [@Fade]='animationSlideState'>フェードアウト・インする<div>

	<div [@slideRight]='animationSlideState' class='slide-animation'>
	右スライドで入ってくる。そして消える<div>

	<div [@SlideLeft]='animationSlideState' class='slide-animation'
	>左スライドで入ってくる。そして消える<div>

スライドは、スタイルの指定に下記が必要。絶対位置で最上部に表示、重ね合わせ最上位、親Divを埋めつくす指定。
"position: absolute; top:0px; z-index: 1; width: 100%; height: 100%; "
※slide-animationとして、GlobalRailgun.scssに定義されている

※注意※ 親DivのStyleが、position:static 以外になっていないと、上に乗っからない。


■アニメーションを実行

BaseViewにいる変数、animationFadeState、animationSlideStateの値を変えるとアニメーションする。
反転処理がBaseViewにあるので、toggleFade()、toggleSlide()、それ呼んでもいい。
呼ぶのは、HTML要素いるコンポーネントでやらないとダメ。

■アニメーションのコールバック
開始、終了で、コールバックできる。

例）
	<div
		[@slideRight]="this.animationSlideState"
		(@slideRight.start)="this.onAnimationEventStart($event)"
		(@slideRight.done)="this.onAnimationEventDone($event)"
		class="slide-animation"
	>
これで、slideRight アニメーションがはじまった時に、onAnimationEventStart
終わった時に、this.onAnimationEventDone が呼ばれる。

*/

import {
	trigger,
	animate,
	transition,
	style,
	state,
	} from '@angular/animations';


/**
 * Slide
 * スライドイン・アウト
 * HACK: パラメータにしてアニメーション定義は同じで切替がよい
 * ※動かないときは、バインドしてるDivが、position:static になってる。それだとleftが無視される
 */
// 右から入ってくる
export const SlideRight = trigger('slideRight', [
	state('slideIn', style({ left: '0%' })),
	state('slideOut', style({ left: '101%' })),
	// state('slideIn', style({ position: 'relative', left: '0%' })),
	// state('slideOut', style({ position: 'relative', left: '101%' })),
	transition('slideIn <=> slideOut', animate('300ms ease-out'))
]);
// 左から入ってくる
export const SlideLeft = trigger('slideLeft', [
	state('slideIn', style({ right: '0%' })),
	state('slideOut', style({ right: '101%' })),
	// state('slideIn', style({ position: 'absolute', right: '0%' })),
	// state('slideOut', style({ position: 'absolute', right: '101%' })),
	transition('slideIn <=> slideOut', animate('300ms ease-out'))
]);

/**
 * Fade
 * フェードイン・アウト
 */
export const Fade = trigger('fade', [
	state('fadeIn', style({ opacity: 1 })),
	state('fadeOut', style({ opacity: 0 })),
	transition('fadeIn <=> fadeOut', animate('1000ms linear'))
]);


/*


01 	ease（初期値） 	イーズ 	開始時と終了時は緩やかに変化します。 	cubic-bezier(0.25, 0.1, 0.25, 1.0)
02 	linear 	リニア 	開始から終了まで一定に変化します。 	cubic-bezier(0.0, 0.0, 1.0, 1.0)
03 	ease-in 	イーズ・イン 	開始時は緩やかに変化、終了に近づくと早く変化します。 	cubic-bezier(0.42, 0.0, 1.0, 1.0)
04 	ease-out 	イーズ・アウト 	開始時は早く変化し、終了時は緩やかに変化します。 	cubic-bezier(0, 0, 0.58, 1.0)
05 	ease-in-out 	イーズ・イン・アウト 	開始時と終了時は、かなり緩やかに変化します。 	cubic-bezier(0.42, 0, 0.58, 1.0)
06 	cubic-bezier(x軸の値, y軸の値, x軸の値, y軸の値) 	キュービック・ベジェ 	変化の度合いを3次ベジェ曲線で指定します。 	-


*/
